import Router from 'vue-router'
import routes from './routes'

export default () => {
    let router =  new Router({
        routes,
        // mode: 'history',
        mode: 'hash',
        linkExactActiveClass: 'exact-active',
        linkActiveClass: 'active',
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return {
                    x: 0,
                    y: 0
                }
            }
        }
    })
    router.beforeEach((to, from, next) => {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (!localStorage.getItem('token')) { 
                next({
                    path: '/login',
                    query: { redirect: to.fullPath }
                })
            } else {
                next();
            }
        } else {
            next();
        }
        // if(to.matched.some(record => record.meta.title)){
        //     document.title = to.meta.title
        // }else{
        //     document.title = ''
        // }
    })
    return router
}